export default [
    {
        key: "elektropanel",
        allArray: "allElektropanelStoyka",
        activeArray: "activeElektropanelStoyka",
        position: "top",
    },
    {
        key: "polka_dlya_klaviaturi",
        allArray: "allPolkaDlyaKlaviaturiStoyka",
        activeArray: "activePolkaDlyaKlaviaturiStoyka",
        position: "bottom",
    },
];
